import { handleActions, createAction } from 'redux-actions';
import pick from 'lodash/pick';
import { cloneDeep, get } from 'lodash';
import countBy from 'lodash/countBy';

export const FETCH_CONVERSATIONS = createAction('FETCH/CONVERSATIONS');
export const FETCH_CONVERSATIONS_SUCCESS = createAction('FETCH/CONVERSATIONS/SUCCESS');
export const FETCH_CONVERSATIONS_FAIL = createAction('FETCH/CONVERSATIONS/FAIL');
export const SELECT_CONVERSATION = createAction('SELECT/CONVERSATION');

export const FETCH_SINGLE_CONVERSATION = createAction('FETCH/SINGLE/CONVERSATION');
export const FETCH_SINGLE_CONVERSATION_SUCCESS = createAction('FETCH/SINGLE/CONVERSATION/SUCCESS');
export const FETCH_SINGLE_CONVERSATION_FAIL = createAction('FETCH/SINGLE/CONVERSATION/FAIL');

export const SEND_CONVERSATION_MESSAGE = createAction('SEND/CONVERSATION/MESSAGE');
export const SEND_CONVERSATION_MESSAGE_SUCCESS = createAction('SEND/CONVERSATION/MESSAGE/SUCCESS');
export const SEND_CONVERSATION_MESSAGE_FAIL = createAction('SEND/CONVERSATION/MESSAGE/FAIL');

export const ADD_NEW_MESSAGE = createAction('ADD/NEW/MESSAGE');

export const TOGGLE_CONVERSATION_BOLD = createAction('TOGGLE/CONVERSATION/BOLD');

export const SET_SEEN_BY_DEALER = createAction('SET_SEEN_BY_DEALER');

const initialState = {
  conversations: {},
  isListLoading: false,
  isItemLoading: false,
  selectedItemHashId: null,
  newConversationsCount: 0,
};

const conversationsReducer = handleActions(
  {
    [FETCH_CONVERSATIONS]: (state) => {
      const newState = cloneDeep(state);
      newState.isListLoading = true;
      return newState;
    },
    [FETCH_CONVERSATIONS_SUCCESS]: (state, { payload, }) => {
      const newConversations = countBy(payload, 'bold').true || 0;
      const conversations = payload.reduce((result, item) => {
        result[item.offer_hash_id] = item;
        return result;
      }, {});
      const newState = cloneDeep(state);
      newState.conversations = conversations;
      newState.isListLoading = false;
      newState.newConversationsCount = newConversations;
      return newState;
    },
    [FETCH_CONVERSATIONS_FAIL]: (state) => {
      const newState = cloneDeep(state);
      newState.isListLoading = true;
      return newState;
    },
    [SELECT_CONVERSATION]: (state, { payload: { hashId, }, }) => {
      const newState = cloneDeep(state);
      newState.selectedItemHashId = hashId;
      return newState;
    },
    [FETCH_SINGLE_CONVERSATION]: (state) => {
      return { ...state, isItemLoading: true, };
    },
    [FETCH_SINGLE_CONVERSATION_SUCCESS]: (state, { payload: { data, hashId, }, }) => {
      const newState = cloneDeep(state);
      newState.isItemLoading = true;
      newState.conversations[hashId].messages = data;
      return newState;
    },
    [FETCH_SINGLE_CONVERSATION_FAIL]: (state) => {
      const newState = cloneDeep(state);
      newState.isItemLoading = false;
      return newState;
    },
    [ADD_NEW_MESSAGE]: (state, { payload: { data: { conversation, message, }, hashId, }, }) => {
      let modifiedConversation = get(state, ['conversations', hashId]);
      if (!get(state, ['conversations', hashId])) {
        modifiedConversation = {
          ...pick(conversation, ['brand', 'model', 'score', 'id', 'display_folder', 'last_message', 'show_path']),
          offer_hash_id: hashId,
          messages: [message],
        };
      }
      const newMessage = {
        author: message.author,
        created_at: message.created_at,
        body: message.body,
      };

      if (get(state, ['conversations', hashId, 'messages'])) {
        const newModifiedConversation = cloneDeep(modifiedConversation);
        newModifiedConversation.messages.push(newMessage);
        newModifiedConversation.last_message = conversation.last_message;
        modifiedConversation = newModifiedConversation;
      }

      const newState = cloneDeep(state);
      newState.conversations[hashId] = modifiedConversation;
      return newState;
    },
    [TOGGLE_CONVERSATION_BOLD]: (state, { payload: { hashId, value, }, }) => {
      const newConversationsCount = get(state, 'newConversationsCount');
      const modifiedNewConversationsCount = value ? newConversationsCount + 1 : newConversationsCount - 1;
      const isConversationBold = get(state, ['conversations', hashId, 'bold']);
      if (!get(state, ['conversations', hashId])) {
 return state;
}
      const modifiedConversation = get(state, ['conversations', hashId]);
      const newModifiedConversation = cloneDeep(modifiedConversation);
      newModifiedConversation.bold = value;

      const newState = cloneDeep(state);
      newState.conversations[hashId] = newModifiedConversation;
      if (isConversationBold !== value) {
        newState.newConversationsCount = modifiedNewConversationsCount > 0 ? modifiedNewConversationsCount : 0;
      }
      return newState;
    },
  },
  initialState
);

export default conversationsReducer;
